import { render, staticRenderFns } from "./detailSetting.vue?vue&type=template&id=3883489e&scoped=true"
import script from "./detailSetting.vue?vue&type=script&lang=js"
export * from "./detailSetting.vue?vue&type=script&lang=js"
import style0 from "./detailSetting.vue?vue&type=style&index=0&id=3883489e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883489e",
  null
  
)

export default component.exports